module.exports = __webpack_public_path__ + "img/ico-remove.e1dc050c.svg";